import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { WORK } from "@/data";
import { ArrowUpRight } from "lucide-react";

export default function Work() {
  return (
    <>
      <PageHeader
        eyebrow="Selected work"
        title="Systems in production"
        subtitle="A snapshot of platforms, products and infrastructure we've delivered across fintech, SaaS and enterprise."
      />

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 space-y-24">
        {WORK.map((w, i) => (
          <Reveal key={w.title}>
            <div className={`grid lg:grid-cols-2 gap-10 items-center ${i % 2 === 1 ? "lg:[direction:rtl]" : ""}`}>
              <div className="group relative rounded-3xl overflow-hidden [direction:ltr]">
                <div className="overflow-hidden aspect-[4/3]">
                  <img src={w.img} alt={w.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
              </div>
              <div className="[direction:ltr]">
                <span className="font-mono-j text-cyan-400 text-sm">0{i + 1}</span>
                <p className="font-mono-j text-xs uppercase tracking-wider text-zinc-500 mt-4">{w.cat}</p>
                <h2 className="font-display font-bold text-4xl sm:text-5xl text-white mt-2">{w.title}</h2>
                <p className="mt-5 text-lg text-zinc-400 leading-relaxed max-w-md">{w.desc}</p>
                <div className="mt-6 inline-flex items-center gap-2 text-cyan-400 font-medium">
                  Case study <ArrowUpRight size={18} />
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </section>
    </>
  );
}
